// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-dropdown-menu .el-dropdown-menu__item:hover {\n  background-color: white;\n  color: #2D46EE;\n}\n", ""]);
// Exports
module.exports = exports;
